// extracted by mini-css-extract-plugin
module.exports = {"layout--article":"SectionTable_layout--article__dtV0J","textSection":"SectionTable_textSection__gxx6q"};